import type { MessageHandlerDeps } from '../message-handler-deps.js';
import type { ApiToBridgeMessage } from '../../types/api-to-bridge-messages.js';
import { handleAgentConfigMessage } from '../handlers/agent-config.js';
import { handlePromptMessage } from '../handlers/prompt.js';
import { handlePromptQueueStateMessage } from '../handlers/prompt-queue-state.js';
import { handleSessionRequestResponseMessage } from '../handlers/session-request-response.js';
import { handleSessionGitRequestMessage } from '../handlers/git/index.js';
import { handleRenameSessionBranchMessage } from '../handlers/rename-session-branch.js';
import { handleSessionArchivedMessage } from '../handlers/session-archived.js';
import { handleSessionDiscardedMessage } from '../handlers/session-discarded.js';
import { handleRevertTurnSnapshotMessage } from '../handlers/revert-turn-snapshot.js';

export function dispatchBridgeSessionMessage(
  msg: Extract<
    ApiToBridgeMessage,
    {
      type:
        | 'agent_config'
        | 'prompt_queue_state'
        | 'prompt'
        | 'session_git_request'
        | 'rename_session_branch'
        | 'session_archived'
        | 'session_discarded'
        | 'revert_turn_snapshot'
        | 'cursor_request_response';
    }
  >,
  deps: MessageHandlerDeps
): void {
  switch (msg.type) {
    case 'agent_config':
      handleAgentConfigMessage(msg, deps);
      break;
    case 'prompt_queue_state':
      handlePromptQueueStateMessage(msg, deps);
      break;
    case 'prompt':
      handlePromptMessage(msg, deps);
      break;
    case 'session_git_request':
      handleSessionGitRequestMessage(msg, deps);
      break;
    case 'rename_session_branch':
      handleRenameSessionBranchMessage(msg, deps);
      break;
    case 'session_archived':
      handleSessionArchivedMessage(msg, deps);
      break;
    case 'session_discarded':
      handleSessionDiscardedMessage(msg, deps);
      break;
    case 'revert_turn_snapshot':
      handleRevertTurnSnapshotMessage(msg, deps);
      break;
    case 'cursor_request_response':
      handleSessionRequestResponseMessage(msg, deps);
      break;
  }
}
